import React from 'react';
import { Card } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import petAiSource from "../assets/video/pet-ai.mp4";
import ORImg1 from "../assets/img/charts.png"
import ORImg2 from "../assets/img/chart-1.png"
import ORImg3 from "../assets/img/chart-2.png"
import miOwnBot from "../assets/img/trading-bot.PNG"
import chatBot from "../assets/video/chatbot.mp4"
import FraudGuard from "../assets/video/ fraud-guard.mp4"

export const Project = () => {
  const projectsData = [
    {
      name: "🛡️ FraudGuard AI",
      source: { 'type': 'video', 'src': FraudGuard },
      description: "FraudGuard AI is a machine learning project I developed to detect fraudulent transactions. I built the model using Python and key data science libraries including pandas, NumPy, Matplotlib, Seaborn, and scikit-learn. he user interface was created using Streamlit, enhanced with custom CSS for styling, allowing users to input transaction details and quickly receive a fraud risk assessment.",
      stack: ["Python", "Keras", "Streamlit", "Tensorflow", "Pandas", "NumPy", "PIL", "Google Collab"],
    },
    {
      name: "🦊 Pet Vision AI",
      source: { 'type': 'video', 'src': petAiSource },
      description: "Pet Vision AI is a deep learning project I developed to classify images of pets as either dogs or cats. I trained the model using a large dataset of labeled pet images, leveraging TensorFlow and Keras to build and fine-tune the neural network. The interface was created using Streamlit, allowing users to upload an image and instantly receive a classification result.",
      stack: ["Python", "Keras", "Streamlit", "Tensorflow", "Pandas", "NumPy", "PIL", "Google Collab"],
    },
    {
      name: "🤖 ChatBot",
      source: { 'type': 'video', 'src': chatBot },
      description: "Implemented a functional chatbot within my digital portfolio to showcase real-time integration with external APIs. The bot handles user interactions with natural flow, retrieving and processing external data dynamically. This project highlights my skills in backend development, API communication, and building interactive user experiences",
      stack: ["React", "Javascript", "HTML"],
    },
    {
      name: "📊 Orange Economy Insights",
      source: { 'type': 'image', 'src': [ORImg1, ORImg2, ORImg3] },
      description: "This project consists of an informative web page focused on the Orange Economy. HTML was used for the creation of the semantic structure of the content. To ensure correct visualization and compatibility, especially in relation to the document generation, a script adaptable to different versions of Pandoc was included. The jQuery library was integrated to allow for efficient DOM manipulation and potential future dynamic interactions on the page.",
      stack: ["HTML", "Javascript", "R", "jQuery", "Pandoc"],
    },
    {
      name: "📉 Forex Trading Bot",
      source: { 'type': 'image', 'src': miOwnBot },
      description: "Automated trading system (Expert Advisor) I developed for the MetaTrader 4 platform. It is designed specifically for the NASDAQ 100 (NAS100) index on a 1-minute chart, and executes trades based on the crossover of two Exponential Moving Averages (EMAs).",
      stack: ["MQL4(MetaQuotes Language 4)", "MetaTrader 4", "TensorFlow"],
    },
    {
      name: "🧪 Mini Projects & Experiments",
      description: `In addition to larger projects, I regularly work on small experiments and exercises using Google Colab. These include:

      🔍 Exploratory data analysis (EDA) with pandas and Matplotlib
      
      🧠 Neural network prototypes using TensorFlow and Keras
      
      📈 Basic data visualizations and model evaluations
      
      🐍 Python practice scripts for automation and data manipulation
      
      🧬 Quick experiments with computer vision (image loading, preprocessing, and classification logic)`,
      stack: ["Python", "NumPy", "pandas", "Matplotlib", "scikit-learn", "TensorFlow", "Keras", "PIL", " io", "requests", "json", "codecs", "Google Colab"],
    },
    
  ];

  return (
    <>
    <h2 className='text-center p-4' id="projects">Projects</h2>
    <div className="projects-grid-responsive">
      {projectsData.map((project, index) => (
        <div key={index} className="project-card-wrapper"> {/* Nuevo contenedor para cada Card */}
          <Card className="project-card">
            <Card.Body>
              <Card.Title>{project.name}</Card.Title>
              <Card.Text style={{ whiteSpace: 'pre-line' }}>{project.description}</Card.Text>
              {project.source && (
                project.source.type === 'image' ? (
                  Array.isArray(project.source.src) && project.source.src.length > 1 ? (
                    <Carousel variant="dark">
                      {project.source.src.map((imageSrc, index) => (
                        <Carousel.Item key={index}>
                          <img
                            className="d-block w-100"
                            src={imageSrc}
                            alt={`Imagen ${index + 1} de ${project.name}`}
                            style={{ objectFit: 'contain', height: 'auto', maxHeight: '300px' }}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  ) : (
                    <Card.Img variant="top" src={project.source.src} style={{ objectFit: 'cover', height: 'auto', maxHeight: '300px' }} />
                  )
                ) : project.source.type === 'video' ? (
                  <video
                  src={project.source.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderTopLeftRadius: '0.375rem',
                    borderTopRightRadius: '0.375rem',
                    borderBottomRightRadius: '0.375rem',
                    borderBottomLeftRadius: '0.375rem',
                    objectFit: 'cover',
                  }}
                  />
                ) : null
              )}
              <Card.Subtitle className="mb-2 mt-2 text-muted"><b>Stack:</b> {project.stack.join(', ')}.</Card.Subtitle>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
    </>
  );
};
